export default {
  merchantList: [],
  merchantListCount: 0,
  merchant: {}
}